import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import StandardProposalContMain from "presentation/view/container/StandardProposal/StandardProposalContMain";

CommonEntrypoint(<StandardProposalContMain/>)